import { render, staticRenderFns } from "./stockStatusGrade.vue?vue&type=template&id=406960d0&scoped=true"
import script from "./stockStatusGrade.vue?vue&type=script&lang=js"
export * from "./stockStatusGrade.vue?vue&type=script&lang=js"
import style0 from "./stockStatusGrade.vue?vue&type=style&index=0&id=406960d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406960d0",
  null
  
)

export default component.exports